module.exports = __webpack_public_path__ + "img/30-avatar male.67a0ef85.png";